<div class="tasks-container">
    <mat-tab-group>
        <mat-tab label="Planuri primite">
            <div id="recivedTasks" *ngIf="recivedPDPsLoaded">
                <app-task-view [tasks]="assignedPDPs" [sectionLabel]="'Planuri de facut'"
                               [type]="'pdp'"></app-task-view>
            </div>
        </mat-tab>
        <mat-tab label="Planuri trimise">
            <div id="givenTasks" *ngIf="createdPDPsLoaded">
                <app-task-view [tasks]="createdPDPs" [sectionLabel]="'Planuri trimise'" [type]="'pdp'"></app-task-view>
            </div>
        </mat-tab>
        <mat-tab label="Creeaza plan">
            <div id="createTask" class="overflow-hidden">
                <div class="card card-custom card-stretch gutter-b">
                    <!-- Header -->
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Adauga un Plan</h3>
                    </div>

                    <div class="form-container">
                        <div class="card-body">
                            <form (ngSubmit)="onSubmit(addPDPForm)" #addPDPForm="ngForm">
                                <div class="form-group">
                                    <label>Titlu plan</label>
                                    <input placeholder="Titlu" ngModel
                                           name="messageTitle" class="form-control"
                                           #messageTitle="ngModel" required>
                                    <div class="error-msg"
                                         *ngIf="!messageTitle.valid && (messageTitle.touched || addPDPForm.submitted)">
                                        Acest
                                        camp este obligatoriu!
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Utilizator</label>
                                    <select name="receiverUserId" ngModel #receiverUserId="ngModel" class="form-control"
                                            required>
                                        <option value="">--Alege un user--</option>
                                        <option *ngFor="let user of users | keyvalue"
                                                value="{{user.value['userId']}}">{{user.value['name']}}</option>
                                    </select>
                                    <div class="error-msg"
                                         *ngIf="receiverUserId.invalid && (receiverUserId.touched || addPDPForm.submitted)">
                                        Acest
                                        camp este obligatoriu!
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Deadline</label>
                                    <div class="date-container">
                                        <input type="datetime-local" placeholder="Alege data" class="form-control"
                                               name="deadline"
                                               #deadlineController="ngModel" ngModel required>
                                        <div class="error-msg"
                                             *ngIf="deadlineController.invalid && (deadlineController.touched || addPDPForm.submitted)">
                                            Acest
                                            camp este obligatoriu!
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Titlu eticheta</label>
                                    <input placeholder="Titlu eticheta" value="Detalii" ngModel
                                           name="labelDevelopmentPlan" class="form-control"
                                           #labelDevelopmentPlan="ngModel">
                                </div>

                                <div class="form-group">
                                    <label>Culoare eticheta</label>
                                    <select placeholder="Culoare eticheta" [(ngModel)]="currentColor"
                                            name="labelColour" class="form-control">
                                        <option value="#D32F2F">Rosu</option>
                                        <option value="#FFEB3B">Galben</option>
                                        <option value="#4CAF50">Verde</option>
                                        <option value="#1976D2">Albastru</option>
                                        <option value="#9C27B0">Mov</option>
                                    </select>
                                    <div class="separator separator-dashed my-6" *ngIf="currentColor"></div>
                                    <div *ngIf="currentColor" class="color-box"
                                         [ngClass]="{
                                         'red-bg': currentColor === '#D32F2F',
                                         'yellow-bg': currentColor === '#FFEB3B',
                                         'green-bg': currentColor === '#4CAF50',
                                         'blue-bg': currentColor === '#1976D2',
                                         'purple-bg': currentColor === '#9C27B0'}">
                                        <span>{{labelDevelopmentPlan.value}}</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Detalii plan</label>
                                    <textarea placeholder="Detalii" ngModel name="messageDetail" class="form-control"
                                              #messageDetail="ngModel"></textarea>
                                </div>

                                <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>

                                <button type="submit"
                                        class=" round-button form-control">
                                    Trimite
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

</div>
